import { CONFIG } from '../../core/config';
import { PlannedMaintenanceList } from '../interfaces/planned-maintenance-list';
import { ViewModel } from '../view-model';
import { EquipmentFailureMode } from './equipment-failure-mode';
import { PlannedMaintenance } from './planned-maintenance';

export class EquipmentFunctionalFailure implements ViewModel, PlannedMaintenanceList {
  friendlyTypeNameSingular: string = 'Functional Failure';
  apiRoute: string = CONFIG.apiRoutes.equipmentFunctionalFailure;

  selected: boolean;
  id: string;
  name: string;
  isSaved: boolean = false;
  failureModes: EquipmentFailureMode[] = [];
  plannedMaintenance: PlannedMaintenance[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.isSaved = data.isSaved;

    if (data.failureModes) {
      this.failureModes = data.failureModes.map((details: EquipmentFailureMode) => {
        const newMode = new EquipmentFailureMode();
        newMode.loadFromJson(details);
        return newMode;
      });
    }

    if (data.plannedMaintenance) {
      this.plannedMaintenance = data.plannedMaintenance.map((details: PlannedMaintenance) => {
        const newPlannedMaintenance = new PlannedMaintenance();
        newPlannedMaintenance.loadFromJson(details);
        return newPlannedMaintenance;
      });
    }
  }
}
